import { useQuery } from '@tanstack/react-query'
import deliveryTypesQueryKeys from 'utils/api/DeliveryType/deliveryTypesQueryKeys'
import { getDeliveryTypes } from 'utils/api/DeliveryType/getDeliveryTypes'

export const useDeliveryVariants = () => {
  return useQuery(deliveryTypesQueryKeys.deliveryTypesList(), () => getDeliveryTypes())
}
